import {Brick, registerBrick, Service} from 'olympe';
import {SUBMIT_PR_SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateSubmitPRSharedMemory.brick';

/**
 * This brick is responsible for fetching the PRs being submitted from the shared memory service.
 */
export default class GetPRsBeingSubmitted extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(Set)} setPRs
     */
    update($, inputs, [forwardEvent, setPRs]) {
        Service.get('submitPRSharedMemory', {topic: SUBMIT_PR_SHARED_MEMORY_TOPICS.PRS_BEING_SUBMITTED})
            .then((data) => {
                setPRs(data.prsBeingSubmitted);
                forwardEvent();
            });
    }
}

registerBrick('01a0618c9101bef61b34', GetPRsBeingSubmitted);
